import { Store, Module, ActionContext } from 'vuex'
import AppConsts from '@/lib/appconst'
import ListModule from './list-module'
import ListState from './list-state'
import Aisle from '../entities/aisle'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
interface AisleState extends ListState<Aisle> {
   
}
class AisleModule extends ListModule<AisleState, any, Aisle>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Aisle>(),
        loading: false,
    }
    actions = {
        async getAll(context: ActionContext<AisleState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/Aisle/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<Aisle>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<AisleState, any>, payload: any) {
            await Ajax.post('/api/services/app/Aisle/Create', payload.data);
        },
        async update(context: ActionContext<AisleState, any>, payload: any) {
            await Ajax.put('/api/services/app/Aisle/Update', payload.data);
        },
        async delete(context: ActionContext<AisleState, any>, payload: any) {
            await Ajax.delete(`/api/services/app/Aisle/DeleteAisle${abp.utils.buildQueryString(Object.keys(payload.data).map((key) => {
                return {
                    name: key,
                    value: payload.data[key]
                }
            }))}`);
        },
        async get(context: ActionContext<AisleState, any>, payload: any) {
            const {data:{result} } = await Ajax.get('/api/services/app/Aisle/GetAisle',{ params : payload.data });
            return result;
        }
    };
    mutations = {
        setCurrentPage(state: AisleState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: AisleState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}
const aisleModule = new AisleModule();
export default aisleModule;